import { useEffect, useId, useRef, useState } from 'react';

import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const TypeAccordion = ({ icon, title, children }) => {
  const [open, setOpen] = useState(false);
  const [maxHeight, setMaxHeight] = useState(0);
  const contentRef = useRef(null);
  const contentId = useId();

  useEffect(() => {
    if (!contentRef.current) return;
    setMaxHeight(open ? contentRef.current.scrollHeight : 0);
  }, [open, children]);

  return (
    <div className="flex w-full flex-col rounded-lg border border-solid border-neutral-200 bg-white">
      <button
        type="button"
        className="flex h-fit min-h-12 cursor-pointer justify-between px-4 py-3.5"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-controls={contentId}>
        <div className="flex items-center gap-2">
          <Icon size={20} icon={icon} />
          <Typography>{title}</Typography>
        </div>
        <Icon size={20} icon={open ? 'chevron-up-linear' : 'chevron-down-linear'} color="neutral" />
      </button>
      <div
        ref={contentRef}
        id={contentId}
        role="region"
        aria-label={typeof title === 'string' ? title : 'Section'}
        style={{ maxHeight }}
        className="overflow-hidden transition-all duration-300">
        <div className="flex flex-col gap-4 rounded-[0px_0px_8px_8px] border-0 border-t border-solid border-t-neutral-200 bg-neutral-50 p-4">
          {children}
        </div>
      </div>
    </div>
  );
};

export default TypeAccordion;
